<ng-template #personCard let-element>
  <div class="my-4 flex flex-row items-center">
    <div class="mr-1 w-5/6">
      <app-user-card
        [username]="element.username"
        [email]="element.email"
        [syncStatus]="element.syncStatus"
        [highlightUsername]="false"
        [isCurrentUser]="isCurrentUser(element)"
      />
    </div>
  </div>
</ng-template>

<ng-template #licenseBadge let-element>
  <div class="my-4">
    @if (!element.license) {
      <div
        [ngClass]="{ invisible: !isStudentSelected(element.id) }"
        *transloco="let t"
      >
        <app-badge
          [text]="
            t('portal.courses.enrollment.licenses.licenseAssignmentBadge')
          "
          type="warning"
        />
      </div>
    } @else {
      <div
        class="flex size-5 cursor-pointer items-center justify-center rounded-full bg-grey-lightGrey leading-none"
        *transloco="let t"
      >
        <mat-icon
          class="p-0.5 text-sm text-grey"
          [matTooltip]="
            t('portal.courses.enrollment.licenses.licenseAssignedText', {
              name: element.username,
            })
          "
          matTooltipPosition="above"
          matTooltipClass="tooltip-above data-hj-suppress"
        >
          check
        </mat-icon>
      </div>
    }
  </div>
</ng-template>

<app-sep-table
  *transloco="let t"
  [columns]="columns"
  [dataSource]="students"
  [hideColumnHeader]="false"
  [primaryButtonTitle]="t('portal.users.creation.createText')"
  [noDataText]="t('portal.users.creation.noDataTableText')"
  [checkboxSelectedText]="t('portal.courses.enrollment.checkboxSelectedText')"
  [type]="sepTableType.SMALL"
  [showSearch]="true"
  [searchValue]="searchTerm"
  [searchPlaceholder]="'general.searchEmployees'"
  (primaryButtonClickedEvent)="primaryButtonClick()"
  (searchChanged)="onSearchTermChanged($event)"
>
  @if (isHRISEnabled()) {
    <div top class="w-full px-4 pb-2 pt-4">
      <app-hris-integration-banner />
    </div>
  }
</app-sep-table>
